
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'search-result-suggested-keywords',
})
export default class extends Vue {
  @Prop() private resultData: Array<object>;
}
